// const contour = document.getElementById('contour');
// const crosscut = document.getElementById('crosscut');
// const fixed = {
//   'of' : 'of',
//   'the': 'the',
//   'u.s.' : 'U.SA.',
//   'usa' : 'USA',
//   'uk' : 'UK'
// }
// let geo = window.location.search.substring(1).trim();


// let initCase = s=>s[0].toUpperCase() + s.substring(1);

// let casify = (s, delimiter)=>{
//   let tokens = geo.split(delimiter);
//   tokens = tokens.map(t=>fixed[t]?fixed[t]:initCase(t))
//   return tokens.join(delimiter);
// }


// if (geo) {
//   /* apps are picky about case in the urls */
//   geo = geo.toLowerCase().replace('%20', ' ');
//   geo = casify(geo, ' ');
//   geo = casify(geo, '-');
//   document.getElementById('geo-name').innerHTML = geo;
//   contour.src = `https://wopr.fathom.info/contour/?countries_v=${geo}&chartmode=pct`;
//   crosscut.src = `https://wopr.fathom.info/crosscut/?countries=${geo}`;
// } else {
//   contour.src = `https://wopr.fathom.info/contour/`;
//   crosscut.src = `https://wopr.fathom.info/crosscut/`;
// }


/* the value of each input should be the id of the view it activates */
let activate=option=>{
  document
    .querySelectorAll('.banyan-app')
    .forEach(appView=>appView.classList.toggle('active', appView.id === option));
  document.getElementById('app-container').className = option;
  if ('mutations' === option) {
    document.getElementById('app-container').scrollTop = 0;
  }
};

document.querySelectorAll('#nav input').forEach(radio=>{
  radio.addEventListener('change', ()=>activate(radio.value));
});

let radio = document.querySelector('#nav input:checked');
activate(radio.value);

let removeStuff = (iframe, hideSelectors, overflowSelectors, attempt=0)=>{
  try {
    let body = iframe.contentWindow.document.body;
    body.style.backgroundColor = 'white';
    body.style.overflow = 'hidden';
    hideSelectors.forEach(selector=>body.querySelector(selector).style.display = 'none');
    overflowSelectors.forEach(selector=>body.querySelector(selector).style.overflow = 'hidden');
  } catch (err) {
    if (attempt < 10) {
      setTimeout(()=>removeStuff(iframe, hideSelectors, overflowSelectors, attempt+1), 1000);
    }
  }
}

// document.getElementById('ne-variants')
//   .querySelectorAll('iframe')
//   .forEach(iframe=>removeStuff(iframe,
//     ['header', '#information', '#selector', '#mutations', '#lineages', '#geographer'],
//     ['#content']));


document.getElementById('us-lineages')
  .querySelectorAll('iframe')
  .forEach(iframe=>{
    if (iframe.classList.contains('large')){
      removeStuff(iframe, ['#chart-toggle'], []);
    } else {
      removeStuff(iframe, ['#identity', '#mobile-chart-mode'], ['main']);
    }
  });

// document.getElementById('lineage-predictions')
//   .querySelectorAll('iframe')
//   .forEach(iframe=>{
//     if (iframe.classList.contains('large')){
//       removeStuff(iframe, ['#chart-toggle'], []);
//     } else {
//       removeStuff(iframe, ['#identity', '#mobile-chart-mode'], ['main']);
//     }
//   });
